import { apiGet } from '@gat-ship/http-client'
import type { ConfiguredPortRef } from '@gat-ship/types'

/**
 * The tenant-configured local port for a location code. Carries the
 * `timeZone` and `useEtaAtPilotStation` flag the create-portcall ETA
 * flow depends on.
 */
export async function getLocalPortRequest(locationCode: string) {
  const { port } = await apiGet<{ port: ConfiguredPortRef }>(
    `ref-data/geography/ports/local/${encodeURIComponent(locationCode)}`
  )
  return port
}
